import { defaultTheme } from 'react-admin';

const theme = {
    ...defaultTheme,
    components: {
        ...defaultTheme.components,
        MuiAppBar: {
            styleOverrides: {
              root: {
                  backgroundColor: "#011b66"
              }
           }
        },
        MuiButton: {
            styleOverrides: {
                textPrimary: {
                    color: "#dd3333"
                }
             }
        }
    }
};

export default theme;